import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Box,
  CircularProgress,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useState } from "react";
import EventCommunicationContainer from "../../../container/EventCommunication.container";
import { formContainer } from "../../../container/form.container";
import { toggleModelShow } from "../../../shared/CustomFunc";
import { CloseIcon } from "../../../shared/icon";
import VSNButton from "../../../shared/VSNButton";
import VSNLabel from "../../../shared/VSNLabel";
import VSNModel from "../../../shared/VSNModel";
import VSNSelect from "../../../shared/VSNSelect";
import VSNSwitch from "../../../shared/VSNSwitch";
import VSNTextField from "../../../shared/VSNTextField";
import VSNTypography from "../../../shared/VSNTypography";
import { EventScheduleStyle } from "./EventScheduleStyle";

const frequencyOption = [
  {
    value: "foundations",
    key: "foundations",
  },
  {
    value: "cardiovascular",
    key: "cardiovascular",
  },
  {
    value: "cancer",
    key: "cancer",
  },
  {
    value: "partnerships",
    key: "partnerships",
  },
];

const EventCommunication = () => {
  const {
    eventCommunicationList,
    dispatch,
    modelState,
    handleEmailPreview,
    handleScheduledDateChange,
    emailPreviewResult,
    handleSwitchChange,
    formPath,
    handleChange,
    handleCreateEventCommunication,
    loaders,
    loadingPreviewId,
    loadingSwitchId,
    EventEmailConfigToEdit,
    isSameConfig,
  } = EventCommunicationContainer();
  const classes = EventScheduleStyle();
  const { formData, formErrors } = formContainer({ formPath });
  const [openDateDialog, setOpenDateDialog] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [activeRowId, setActiveRowId] = useState(null);
  const [emailTypes, setEmailTypes] = useState({});
  const [selectedPreviewEvent, setSelectedPreviewEvent] = useState(null);

  if (loaders?.createEventSchedule) {
    return (
      <Box
        sx={{
          height: "200px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        marginY="auto"
      >
        <CircularProgress color="inherit" />
      </Box>
    );
  }

  const selectedValue =
    emailTypes[selectedPreviewEvent?.id] || frequencyOption[0]?.value;

  const handleFrequencyChange = (e) => {
    const { value } = e.target;
    setEmailTypes((prev) => ({
      ...prev,
      [selectedPreviewEvent?.id]: value,
    }));

    if (selectedPreviewEvent?.name && selectedPreviewEvent?.id) {
      handleEmailPreview(selectedPreviewEvent?.name, value);
    }
  };

  return (
    <Box mt={3}>
      <Grid container spacing={3} pb={3}>
        <Grid item xs={12} md={12}>
          <Stack direction="row" alignItems="center" mb={0.5}>
            <VSNTypography color="#86650A" variant="body2" fontWeight={700}>
              TURN ON EMAIL FLOW
            </VSNTypography>
            <VSNSwitch
              name="send_emails"
              checked={formData?.send_emails || false}
              onChange={handleSwitchChange}
            />
          </Stack>
          <VSNTypography color="#3A3A40" variant="body2" mb={2}>
            Automatically send scheduled emails to participants during the event
            lifecycle.
          </VSNTypography>

          <Stack
            sx={{
              padding: 3,
              background: "#ffffff",
              borderRadius: 4,
              boxShadow: "0px 0px 14px 0px #0000001A",
            }}
          >
            <VSNLabel required label="Additional Note" />
            <VSNTextField
              name="additional_note"
              value={formData?.additional_note || ""}
              placeholder="Please add additional note here"
              onChange={handleChange}
              fullWidth
              error={!!formErrors?.additional_note}
              helperText={formErrors?.additional_note}
            />
          </Stack>

          <Stack
            direction="row"
            flexWrap="wrap"
            gap={2}
            mt={3}
            justifyContent="flex-end"
          >
            <VSNButton
              className={classes.createLinkButton}
              type="submit"
              handleClick={handleCreateEventCommunication}
              isLoading={loaders?.UpdateEventSchedule}
              disabled={isSameConfig}
            >
              Save
            </VSNButton>
          </Stack>
        </Grid>
      </Grid>
      <Box mb={2}>
        <VSNTypography fontSize={18} fontWeight={600}>
          Manage Event Emails
        </VSNTypography>
        <VSNTypography>
          Manage, schedule, and monitor the delivery of event-related
          communications.
        </VSNTypography>
      </Box>
      {EventEmailConfigToEdit?.send_emails ? (
        <Box>
          {!loaders?.eventCommunicationList ? (
            <TableContainer
              component={Paper}
              sx={{ width: "100%", margin: "auto", px: 2 }}
            >
              <Table sx={{ minWidth: 1300 }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Email Name
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Enable Email
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Scheduled Date
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Sent Date</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Delivery Status
                    </TableCell>

                    <TableCell sx={{ fontWeight: "bold" }}>
                      Email Preview
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {eventCommunicationList?.length > 0 ? (
                    eventCommunicationList?.map((event, index) => (
                      <TableRow key={index}>
                        <TableCell>{event?.event_name}</TableCell>
                        <TableCell align="center">
                          {loadingSwitchId === event?.id ? (
                            <CircularProgress size={16} />
                          ) : (
                            <VSNSwitch
                              checked={event?.send_email}
                              onChange={(e) =>
                                handleScheduledDateChange(
                                  event?.id,
                                  e.target.checked,
                                  "toggle"
                                )
                              }
                              color="primary"
                            />
                          )}
                        </TableCell>
                        <TableCell>
                          <VSNTypography>
                            {dayjs(event?.scheduled_date).format(
                              "YYYY-MM-DD"
                            ) || "N/A"}

                            {event?.status === "Pending" && (
                              <IconButton
                                onClick={() => {
                                  setOpenDateDialog(true);
                                  setSelectedDate(dayjs(event?.scheduled_date));
                                  setActiveRowId(event?.id);
                                }}
                                sx={{ verticalAlign: -4 }}
                              >
                                <EditOutlinedIcon
                                  style={{ color: "#29904C" }}
                                  fontSize="small"
                                />
                              </IconButton>
                            )}
                          </VSNTypography>
                        </TableCell>

                        <TableCell>
                          <Stack direction="row" alignItems="center" gap={1}>
                            <VSNTypography>
                              {event?.sent_date
                                ? dayjs(event?.sent_date).format("YYYY-MM-DD")
                                : "-"}
                            </VSNTypography>
                          </Stack>
                        </TableCell>

                        <TableCell>
                          {" "}
                          <VSNTypography
                            sx={{
                              padding: "5px 10px",
                              borderRadius: 1.5,
                              width: "max-content",
                              border: `1px solid ${
                                event.status === "Pending"
                                  ? "#F7A23B "
                                  : "#34A259"
                              }`,
                              backgroundColor:
                                event.status === "Pending"
                                  ? "#FFF8EB "
                                  : "#F2FBF5",
                              color:
                                event.status === "Pending"
                                  ? "#F7A23B "
                                  : "#34A259",
                            }}
                          >
                            {event?.status}
                          </VSNTypography>
                        </TableCell>

                        <TableCell>
                          <VSNButton
                            handleClick={() => {
                              if (event?.is_service_level) {
                                const selectedEmailType =
                                  emailTypes[event?.id] ??
                                  frequencyOption[0].value;
                                setEmailTypes((prev) => ({
                                  ...prev,
                                  [event.id]: selectedEmailType,
                                }));
                                setSelectedPreviewEvent({
                                  id: event?.id,
                                  name: event?.event_name,
                                  is_service_level: event?.is_service_level,
                                });
                                handleEmailPreview(
                                  event?.event_name,
                                  selectedEmailType
                                );
                              } else {
                                setSelectedPreviewEvent(null);
                                handleEmailPreview(event?.event_name, "");
                              }
                              dispatch(
                                toggleModelShow("emailPreviewResultModal", true)
                              );
                            }}
                            sx={{
                              background: "#555FDD0D",
                              color: "#555FDD",
                              px: 2,
                              minWidth: 116,
                              py: 1,
                              fontWeight: "normal",
                              "&:disabled": {
                                background: "#555FDD0D",
                              },
                              "& .content": {
                                fontSize: 14,
                              },
                            }}
                          >
                            View Preview
                          </VSNButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        sx={{ textAlign: "center", color: "gray" }}
                      >
                        No Email Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box
              sx={{
                minHeight: "240px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
            </Box>
          )}
        </Box>
      ) : (
        <Box className={classes.notDataFound}>
          <VSNTypography>
            Turn on emails to view and manage event communication details.
          </VSNTypography>
        </Box>
      )}

      {modelState?.emailPreviewResultModal && (
        <VSNModel
          open={modelState?.emailPreviewResultModal}
          onClose={() => {
            dispatch(toggleModelShow("emailPreviewResultModal"));
          }}
          disableEnforceFocus
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          mobileDrawer
          className={classes.emailPreviewModal}
        >
          <Box sx={{ position: "relative" }}>
            <Box className={classes.modalHeader}>
              <Stack
                py={3}
                gap={{ xs: 2, smd: 5 }}
                direction="row"
                flexWrap="wrap"
              >
                <Stack gap={0.5} width={{ xs: "100%", smd: "auto" }}>
                  <VSNTypography variant="h4" className={classes.title}>
                    Email Preview
                  </VSNTypography>
                  <VSNTypography variant="body1">
                    Here’s how your email will appear to members.
                  </VSNTypography>
                </Stack>
                {selectedPreviewEvent?.is_service_level && (
                  <Stack width={{ xs: "100%", xsm: "auto" }}>
                    <VSNTypography sx={{ fontSize: 14, fontWeight: 700 }}>
                      Service Level
                    </VSNTypography>
                    <VSNSelect
                      formControlSx={{ flex: 1 }}
                      sx={{
                        minWidth: 160,
                        "& .MuiSelect-select": {
                          fontSize: 16,
                          fontWeight: "normal",
                          paddingLeft: "12px",
                          textAlign: "start",
                        },
                      }}
                      value={selectedValue}
                      placeHolder="Frequency"
                      label="Frequency"
                      onChange={handleFrequencyChange}
                      options={frequencyOption}
                    />
                  </Stack>
                )}
              </Stack>

              <Divider sx={{ borderColor: "#EAEDF0" }} />
            </Box>
            {loaders?.emailPreviewResult ? (
              <Box
                sx={{
                  minHeight: "580px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress color="inherit" />
              </Box>
            ) : (
              <Box
                className="editable-email"
                dangerouslySetInnerHTML={{ __html: emailPreviewResult }}
              />
            )}
          </Box>
        </VSNModel>
      )}

      {openDateDialog && (
        <VSNModel open={openDateDialog} className={classes.leavingModel}>
          <div className={classes.container}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className={classes.modalHead}
            >
              <DialogTitle id="draggable-dialog-title" component="h4">
                Edit Scheduled Date
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={() => setOpenDateDialog(!openDateDialog)}
              >
                <CloseIcon />
              </IconButton>
            </Stack>

            <Box p={4}>
              <VSNTypography textAlign="left" fontWeight={700}>
                Enter Date*
              </VSNTypography>
              <DesktopDatePicker
                sx={{
                  width: "100%",
                  "& .MuiInputBase-input.MuiOutlinedInput-input": {
                    padding: "9.45px",
                  },
                }}
                disablePast
                fullWidth
                variant="standard"
                onChange={(newValue) => setSelectedDate(newValue)}
                value={selectedDate}
              />
            </Box>

            <DialogActions>
              <Stack
                width="100%"
                direction={{ xs: "column", xts: "row" }}
                gap={{ md: 3, xs: 2 }}
                className={classes.attentionButton}
                justifyContent="center"
              >
                <VSNButton
                  handleClick={() => setOpenDateDialog(false)}
                  className={classes.cancelButton}
                  variant="outlined"
                >
                  Cancel
                </VSNButton>
                <VSNButton
                  handleClick={() => {
                    handleScheduledDateChange(
                      activeRowId,
                      selectedDate?.format("YYYY-MM-DD"),
                      "date"
                    );

                    setOpenDateDialog(false);
                  }}
                  className={classes.logoutButton}
                  // isLoading={isLoading}
                >
                  Save Date
                </VSNButton>
              </Stack>
            </DialogActions>
          </div>
        </VSNModel>
      )}
    </Box>
  );
};

export default EventCommunication;
